import styled from "styled-components";

export const FlexColumn = styled.div<{
  gap?: number;
  minWidthZero?: boolean;
  padding?: number | string;
  alignItems?: string;
  reverse?: boolean;
}>`
  display: flex;
  flex-direction: ${({ reverse }) => (reverse ? "column-reverse" : "column")};
  gap: ${({ gap }) => (gap ?? 1) * 8}px;
  ${({ minWidthZero }) => (minWidthZero ? "min-width: 0;" : "")}
  ${({ padding }) => (padding ? `padding: ${padding};` : "")};
  ${({ alignItems }) => (alignItems ? `align-items: ${alignItems};` : "")};
`;

export const FlexRow = styled.div<{
  gap?: number;
  padding?: number | string;
  alignItems?: string;
  reverse?: boolean;
  justifyContent?: string;
}>`
  display: flex;
  flex-direction: ${({ reverse }) => (reverse ? "row-reverse" : "row")};
  ${({ alignItems }) => (alignItems ? `align-items: ${alignItems};` : "align-items: center;")};
  column-gap: ${({ gap }) => (gap ?? 1) * 8}px;
  ${({ padding }) => (padding ? `padding: ${padding};` : "")};
  ${({ justifyContent }) => (justifyContent ? `justify-content: ${justifyContent};` : "")};
`;
